import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4 md:h-20">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                {site.name}
              </span>
              <span className="mt-0.5 text-[10px] font-label tracking-[0.2em] text-foreground-500">
                GUA·ONLINE
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
            {navLinks.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `rounded-md px-3.5 py-2 text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <Link
              to="/hot"
              className="flex items-center gap-1.5 rounded-md border border-background-300 px-3.5 py-2 text-sm font-label whitespace-nowrap text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
            >
              <i className="ri-fire-line" />
              今日热榜
            </Link>
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              推荐话题
            </Link>
          </div>

          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col px-4 py-3">
            {navLinks.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-label transition-colors cursor-pointer ${
                    isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-2 rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-label text-background-50 cursor-pointer"
            >
              推荐话题
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}